import Phaser from 'phaser';

import { BlackjackMainScene } from '../../scenes/blackjack-main-scene';
import { ResizeMetrics } from '../../model/resize-metrics';
import { CroupierBettingBoxViewModel } from './croupier-betting-box-view-model';
import { CroupierHandView } from './croupier-hand-view';

export class CroupierBettingBoxView extends Phaser.GameObjects.Container {
  private currentResizeMetrics?: ResizeMetrics;
  private graphics: Phaser.GameObjects.Graphics;
  private croupierHandView: CroupierHandView;

  constructor(
    scene: BlackjackMainScene,
    x: number,
    y: number,
    private viewModel: CroupierBettingBoxViewModel,
  ) {
    super(scene, x, y);

    this.graphics = scene.add.graphics();
    this.add(this.graphics);

    this.croupierHandView = new CroupierHandView(scene, 0, 0, viewModel.croupierHandViewModel);
    this.add(this.croupierHandView);

    this.setName(CroupierBettingBoxView.name);
    scene.add.existing(this);
  }

  public onResize(resizeMetrics: ResizeMetrics) {
    this.croupierHandView?.onResize(resizeMetrics);

    this.currentResizeMetrics = resizeMetrics;
    this.refreshLayout();
  }

  private refreshLayout(): void {
    if (!this.currentResizeMetrics) {
      return;
    }
    const layoutConfig = this.currentResizeMetrics.layoutConfig;
    const scalingMetrics = this.currentResizeMetrics.scalingMetrics;

    const boxScale = 0.8;

    const controlsWidth = layoutConfig.bettingBoxWidth * boxScale * scalingMetrics.scaleFactor;
    const controlsHeight = layoutConfig.bettingBoxHeight * boxScale * scalingMetrics.scaleFactor;

    const xPos = layoutConfig.boardWidth * 0.5;
    const yPos = layoutConfig.boardHeight * 0.15;

    this.setSize(controlsWidth, controlsHeight);
    this.setPosition(
      xPos * scalingMetrics.scaleFactor + scalingMetrics.scaledOffsetX,
      yPos * scalingMetrics.scaleFactor,
    );

    this.croupierHandView.setPosition(0, 0);

    this.drawGraphics();
  }

  private drawGraphics(): void {
    this.graphics.clear(); // Clear previous drawings

    this.graphics.lineStyle(3, this.viewModel.borderColor, this.viewModel.borderAlpha);
    this.graphics.strokeRoundedRect(
      this.width * -0.5,
      this.height * -0.5,
      this.width,
      this.height,
      this.width * 0.05,
    );
    this.graphics.setDepth(1);
  }
}
